/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetStripeCheckoutStatusSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type GetStripeCheckoutStatusRequest = {
  /**
   * Stripe Checkout session identifier
   */
  sessionId: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type GetStripeCheckoutStatusSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetStripeCheckoutStatusSecurity$outboundSchema: z.ZodMiniType<
  GetStripeCheckoutStatusSecurity$Outbound,
  GetStripeCheckoutStatusSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getStripeCheckoutStatusSecurityToJSON(
  getStripeCheckoutStatusSecurity: GetStripeCheckoutStatusSecurity,
): string {
  return JSON.stringify(
    GetStripeCheckoutStatusSecurity$outboundSchema.parse(
      getStripeCheckoutStatusSecurity,
    ),
  );
}

/** @internal */
export type GetStripeCheckoutStatusRequest$Outbound = {
  session_id: string;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const GetStripeCheckoutStatusRequest$outboundSchema: z.ZodMiniType<
  GetStripeCheckoutStatusRequest$Outbound,
  GetStripeCheckoutStatusRequest
> = z.pipe(
  z.object({
    sessionId: z.string(),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionId: "session_id",
      gramSession: "Gram-Session",
    });
  }),
);

export function getStripeCheckoutStatusRequestToJSON(
  getStripeCheckoutStatusRequest: GetStripeCheckoutStatusRequest,
): string {
  return JSON.stringify(
    GetStripeCheckoutStatusRequest$outboundSchema.parse(
      getStripeCheckoutStatusRequest,
    ),
  );
}
